import type { ComponentProps } from 'svelte';
import { createWidgetSingleton } from '../create-widget-singleton';
import StandaloneAntonioChat from './StandaloneAntonioChat.svelte';

export interface AntonioWidgetConfig {
	apiKey: string;
	containerId?: string;
	baseUrl?: string;
	model?: string;
	chatPlaceholder?: string;
	cssPath?: string; // Path to widget-antonio.css, defaults to auto-detection
}

// Global BotbakeryAntonioWidget API - singleton that manages widget instances
export const BotbakeryAntonioWidget = createWidgetSingleton<
	ComponentProps<typeof StandaloneAntonioChat>
>(StandaloneAntonioChat, 'botbakery-antonio-widget', 'widget-antonio');
